import { useEffect, useState } from "react";
import { IFAQ } from "../admin/faqs/adminFaqs";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../../firebase";
import LoadingBalls from "../../core/loadingBalls";
import ExpandableFAQ from "./expandableFaq";

export default function FAQPage() {

    const [faqs, setFaqs] = useState<IFAQ[] | null>(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getFaqs();
        // eslint-disable-next-line
    }, [])

    const getFaqs = async () => {
        try {
            setLoading(true);
            let docs: IFAQ[] = [];

            const q = query(collection(db, "faqs"), where("display", "==", true));
            const docsSnap = await getDocs(q);
            if (docsSnap.empty) {
                setLoading(false);
                return null;
            }
            docsSnap.forEach(doc => {
                docs.push({
                    id: doc.id,
                    question: doc.data().question,
                    answer: doc.data().answer,
                    display: doc.data().display,
                    order: doc.data().order
                })
            })
            setFaqs(docs.sort((a, b) => a.order - b.order));
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    return (
        <main className="bg-white min-h-[70vh] pb-32 pt-24 overflow-hidden">
            {/* Header */}
            <div className="max-w-4xl mx-auto px-6 text-center mb-20 animate-superfade">
                <p className="text-secondary font-bold tracking-[0.4em] text-xs uppercase mb-6">Central de Ajuda</p>
                <h1 className="font-outfit text-4xl md:text-6xl font-black text-primary tracking-widest mb-8">
                    PERGUNTAS <br className="hidden md:block" /> FREQUENTES
                </h1>
                <div className="flex justify-center mb-10">
                    <div className="w-20 h-1 bg-secondary rounded-full" />
                </div>
                <p className="text-xl text-mono leading-relaxed max-w-2xl mx-auto">
                    Tudo o que você precisa saber para negociar com segurança e exclusividade em nossa plataforma.
                </p>
            </div>

            <div className="px-6 animate-superfade">
                {
                    loading ?
                        <div className="flex justify-center py-20">
                            <LoadingBalls />
                        </div>
                        :
                        <div className="space-y-4">
                            {faqs?.map((f, i) => (
                                <ExpandableFAQ faq={f} index={i} key={i}/>
                            ))}
                        </div>
                }
            </div>
            
            {/* Background Hint */}
            <div className="fixed top-0 right-0 w-[500px] h-[500px] bg-secondary/[0.02] rounded-full blur-[120px] -z-10 pointer-events-none" />
            <div className="fixed bottom-0 left-0 w-[300px] h-[300px] bg-primary/[0.02] rounded-full blur-[100px] -z-10 pointer-events-none" />
        </main>
    )
}
